import { render } from "./onboarding.vue?vue&type=template&id=7e94c4d4"
import script from "./onboarding.vue?vue&type=script&lang=js"
export * from "./onboarding.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__